(function (algolia, addPriceInputs) {
  const client = algolia.externals.algoliasearch(
    algolia.config.app_id,
    algolia.config.search_api_key
  );
  const index = client.initIndex(algolia.config.index_prefix + 'products');
  class QuickViewPriceInputs {
    variantSelects;
    form;
    variants;
    algoliaIndex;
    addPriceInputs;

    constructor(algoliaIndex, addPriceInputs) {
      this.algoliaIndex = algoliaIndex;
      this.addPriceInputs = addPriceInputs;
      this.form = document.querySelector('.product-form form');
      this.variantSelects = document.querySelectorAll('variant-selects select');

      for (const variantSelect of this.variantSelects) {
        variantSelect.addEventListener('change', this.onVariantChange);
      }

      this.getVariants();
    }

    async getVariants() {
      const variantSelectsEl = document.querySelector('variant-selects');
      let variantIds = [document.querySelector('[name="id"]').value];

      if(!!variantSelectsEl) {
        variantIds = variantSelectsEl.dataset.variantIds.split(',');
      }

      const { results } = await this.algoliaIndex.getObjects(variantIds);
      this.variants = results;

      /**
       * Wait until variant data has been retrieved before re-enabling
       * variant options and the add to cart button so that discounts
       * can be properly applied when adding a product to cart
       */
      for (const variantSelect of this.variantSelects) {
        variantSelect.removeAttribute('disabled');
      }

      const addBtn = this.form.querySelector('#AddToCartButton');
      if (addBtn.dataset.unavailable == 'false') {
        addBtn.removeAttribute('disabled');
      }
    }

    getVariantByTitle(title) {
      for (const variant of this.variants) {
        if (variant.variant_title === title) {
          return variant;
        }
      }

      throw new Error(`Variant "${title}" is not found`);
    }

    onVariantChange = e => {
      const variantTitle = e.target.value;
      const variant = this.getVariantByTitle(variantTitle);
      this.addPriceInputs(this.form, variant);
    }
  }

  class QuickViewModal extends ModalDialog {
    content;

    constructor() {
      super();
      this.content = document.getElementById('quick-view-modal-content');
    }

    hide() {
      super.hide();
      this.content.innerHTML = '';
    }

    show(opener) {
      super.show(opener);
      this.renderProductInfo();
    }

    renderProductInfo() {
      const handle = this.openedBy.dataset.handle;
      fetch(`/products/${handle}?view=quick-view`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const quickViewContent = html.getElementById('quick-view-template');

          if (quickViewContent && this.content) this.content.innerHTML = quickViewContent.innerHTML;

          new QuickViewPriceInputs(index, addPriceInputs);

          if (!window.yotpo) return;
          window.yotpo.initWidgets();
        });
    }
  }

  customElements.define('quick-view-modal', QuickViewModal);

})(window.algoliaShopify, window.addPriceInputs);
